import React from 'react';
import { useParams } from 'react-router-dom';
import { Check, Phone, Mail } from 'lucide-react';

const ProductDetail = () => {
  const { slug } = useParams();

  // Product data mapping
  const productData = {
    'ups': {
      title: 'UPS Systems',
      description: 'Uninterruptible power supply systems for critical loads and backup power.',
      specs: ['1kVA - 500kVA', 'Online & Line-Interactive', 'Hot-swappable batteries', 'Remote monitoring'],
      features: ['Clean power output', 'Automatic voltage regulation', 'Battery management', 'LCD display']
    },
    'solar': {
      title: 'Solar Panels',
      description: 'High-efficiency solar panels from leading manufacturers.',
      specs: ['100W - 600W', 'Monocrystalline & Polycrystalline', '25-year warranty', 'High efficiency'],
      features: ['PID resistant', 'Low light performance', 'Durable frame', 'Easy installation']
    },
    'generators': {
      title: 'Generators',
      description: 'Diesel, gas, and hybrid generators for backup and prime power.',
      specs: ['5kVA - 2000kVA', 'Diesel, Gas, Hybrid', 'Automatic transfer switch', 'Soundproof options'],
      features: ['Reliable operation', 'Fuel efficiency', 'Remote monitoring', 'Low maintenance']
    },
    'access-control': {
      title: 'Access Control Systems',
      description: 'Advanced access control systems for security and management.',
      specs: ['Biometric, RFID, Smart', 'Multi-user support', 'Integration ready', 'Cloud management'],
      features: ['Real-time monitoring', 'Access logs', 'Remote management', 'Scalable']
    },
    'security': {
      title: 'Security Systems',
      description: 'Comprehensive security systems for residential and commercial properties.',
      specs: ['CCTV, Alarms, Monitoring', 'HD cameras', 'Night vision', 'Mobile alerts'],
      features: ['24/7 monitoring', 'Motion detection', 'Cloud storage', 'Easy installation']
    },
    'cabling': {
      title: 'Structured Cabling',
      description: 'Professional structured cabling for data and voice networks.',
      specs: ['Cat6, Fiber, Networks', 'High-speed data', 'Future-proof', 'Standards compliant'],
      features: ['High bandwidth', 'Low latency', 'Scalable', 'Professional installation']
    },
    'pme': {
      title: 'PME Meters',
      description: 'Power monitoring and energy management systems.',
      specs: ['1-Phase, 3-Phase', 'Real-time monitoring', 'Data logging', 'Remote access'],
      features: ['Energy tracking', 'Load management', 'Cost optimization', 'Reporting']
    }
  };

  const product = productData[slug] || productData['ups'];

  return (
    <div className="pt-20">
      <section className="py-16 bg-gradient-to-r from-[#006D77] to-[#008B8B] text-white">
        <div className="container mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-5xl font-bold">{product.title}</h1>
          <p className="text-xl text-white/80 mt-4 max-w-2xl">{product.description}</p>
        </div>
      </section>
      <section className="py-16">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Specifications</h2>
              <ul className="space-y-2">
                {product.specs.map((spec, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-gray-700">
                    <Check size={18} className="text-[#006D77]" />
                    {spec}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Key Features</h2>
              <ul className="space-y-2">
                {product.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-gray-700">
                    <Check size={18} className="text-[#006D77]" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="mt-12 p-8 bg-gray-50 rounded-2xl">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Get a Quote</h3>
            <div className="flex flex-wrap gap-4">
              <button className="bg-[#006D77] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#00555C] transition-all flex items-center gap-2">
                <Phone size={18} />
                Call 0735 338 408
              </button>
              <button className="border-2 border-[#006D77] text-[#006D77] px-6 py-3 rounded-full font-semibold hover:bg-[#006D77] hover:text-white transition-all flex items-center gap-2">
                <Mail size={18} />
                Email Inquiry
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetail;
